const getDeskTypesQuantity = ({ report }) => report.services.deskTypesQuantity;

export default getDeskTypesQuantity;
